import { typeColour } from "./viewConfig";

// A stable accent colour per object type: the admin's colour from the view
// configuration when one is given, else the colour the server gives by
// default - typeColour/typeInfo already fall back to that for a type the
// configuration doesn't (yet) list.
export default function colourForType(type = "", config) {
  return typeColour(config, type);
}
